<template>
    <div class="page">
        <div class="list">
            <!-- <div class="item">
                <div class="top">
                    活动名称
                </div>
                <div class="footer">
                    <div class="left">
                        <div class="time">2020-02-20</div>
                        <div class="place">成都金堂</div>
                    </div>
                    <div class="btn">查看详情</div>
                </div>
            </div>
            <div class="line"></div>
            <div class="item">
                <div class="top">
                    活动名称
                </div>
                <div class="footer">
                    <div class="left">
                        <div class="time">2020-02-20</div>
                        <div class="place">成都金堂</div>
                    </div>
                    <div class="btn">查看详情</div>
                </div>
            </div>
            <div class="line"></div> -->
        </div>
        <no-content :msg="'暂无活动'" v-if="showNoContent"></no-content>
    </div>
</template>

<script>
import noContent from "../../components/no-content/no-content";
export default {
    name: "activity-list",
    components: {
        "no-content": noContent
    },
    data() {
        return {
            list: [],
            showNoContent: true
        };
    }
};
</script>

<style lang="scss" scoped src="./activity-list.scss">
</style>